import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearchPlus, faSearchMinus, faSync } from '@fortawesome/free-solid-svg-icons';
import { Button } from "reactstrap";
import "./index.scss";
const PdfControls = ({ className = '', _refresh, _zoomInOcr, _zoomOutOcr, _activeEditTabs, activeLink, disabledZoomFlag, disabledZoomInButton, disabledZoomOutButton }) => {

	return (
		<>
		{/* {console.log("chejcig", disabledZoomInButton, disabledZoomFlag)} */}
			<div className={`pdf-controler d-inline-flex align-items-center ${className}`} id="pdfZoom">
				<Button disabled={disabledZoomFlag || disabledZoomOutButton} color={`${activeLink !== 'zoomOut' ? 'link' : 'secondary'}`} onClick={() => _zoomOutOcr('zoomOut')} data-toggle="tooltip" data-placement="top" title="Zoom Out">
					<FontAwesomeIcon icon={faSearchMinus} />
				</Button>
				<Button disabled={disabledZoomFlag || disabledZoomInButton} color={`${activeLink !== 'zoomIn' ? 'link' : 'secondary'}`} onClick={() => _zoomInOcr('zoomIn')} data-toggle="tooltip" data-placement="top" title="Zoom In" className="zoomInBtn">
					<FontAwesomeIcon icon={faSearchPlus} />
				</Button>
				{/* <Button disabled={disabledZoomOutButton} color={`${activeLink !== 'zoomOut' ? 'link' : 'secondary'}`} onClick={() => _zoomOutOcr('zoomOut')} data-toggle="tooltip" data-placement="top" title="Zoom Out">
					<FontAwesomeIcon icon={faSearchMinus} />
				</Button>
				<Button disabled={disabledZoomInButton} color={`${activeLink !== 'zoomIn' ? 'link' : 'secondary'}`} onClick={() => _zoomInOcr('zoomIn')} data-toggle="tooltip" data-placement="top" title="Zoom In" className="zoomInBtn">
					<FontAwesomeIcon icon={faSearchPlus} />
				</Button> */}

				<Button color='link' onClick={(vl) => _refresh(true)} className='resetBtn' data-toggle="tooltip" data-placement="top" title="Refresh">
					<FontAwesomeIcon icon={faSync} />
				</Button>
			</div>
		</>
	)
}


export default PdfControls;